import { createTransform } from 'redux-persist';

import { Project } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type PersistableProject = Project & { isRemoved: false };
type PrunedProjectsState = {
  projectIds: string[];
  projectsById: Record<string, PersistableProject>;
};

const isPersistableProject = (
  project: Project
): project is PersistableProject => project && !project.isRemoved;

export const pruneProjects = createTransform<
  ReduxState['projects'],
  PrunedProjectsState,
  ReduxState
>(
  (projectsState) => {
    const persistableProjectsState: PrunedProjectsState = {
      projectIds: [],
      projectsById: {},
    };

    projectsState.projectIds.forEach((id) => {
      const project = projectsState.projectsById[id];
      if (!isPersistableProject(project)) {
        return;
      }
      persistableProjectsState.projectIds.push(id);
      persistableProjectsState.projectsById[id] = project;
    });

    return persistableProjectsState;
  },
  null,
  { whitelist: ['projects'] }
);
